import React, { useEffect, useState } from "react";
import { Zap } from "lucide-react";
import api from "../lib/api";

/* "+10% wins" badge for customers under a boosted agent (master-admin per-agent win rate). */
export const WinBoostBadge = ({ ta, className = "" }) => {
  const [boost, setBoost] = useState(0);
  const [agent, setAgent] = useState("");
  useEffect(() => { api.get("/auth/my-agent").then((r) => { setBoost(r.data?.agent?.win_boost_pct || 0); setAgent(r.data?.agent?.name || ""); }).catch(() => {}); }, []);
  if (!boost) return null;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-gradient-to-r from-amber-400 to-orange-500 text-white text-[10px] font-black shadow ${className}`} data-testid="win-boost-badge" title={ta ? `${agent} agent வழியாக இணைந்ததால் உங்கள் வெற்றித் தொகை +${boost}%` : `Joined via ${agent} — your win amounts are boosted by ${boost}%`}>
      <Zap className="w-3 h-3" />{ta ? `+${boost}% வெற்றி` : `+${boost}% wins`}
    </span>
  );
};
